<script setup>
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import apiClient from "@/axiosConfig";

toastr.options = {
  positionClass: "toast-bottom-right",
  closeButton: true,
  progressBar: true,
  timeOut: 5000,
};

const callback = async (response) => {
  try {
    const credential = response.credential;
    const payload = { token: credential };
    const apiResponse = await apiClient.post("/auth/login-with-google", payload);
    document.cookie = `authToken=${apiResponse.data.token}; path=/; max-age=86400;`;
    toastr.success("Google Login successful!", "Success");
    const redirect = new URLSearchParams(window.location.search).get("redirect");
    window.location.href = redirect && redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/dashboard";
  } catch (error) {
    if (error.response && error.response.status === 400) {
      toastr.error(error.response.data.message, "Login Failed");
    } else {
      toastr.error("An error occurred. Please try again later.", "Error");
    }
  }
};
</script>

<template>
  <div class="min-h-screen grid lg:grid-cols-2 bg-base">
    <!-- Brand panel -->
    <div class="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden border-r border-line">
      <div class="absolute inset-0 bg-hero-glow"></div>
      <div class="absolute inset-0 bg-grid-dark bg-grid opacity-60 [mask-image:radial-gradient(80%_80%_at_30%_30%,black,transparent)]"></div>
      <a href="/" class="relative flex items-center gap-3">
        <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-10" />
        <span class="text-lg font-extrabold text-white">Akademi<span class="text-brand">Siber</span></span>
      </a>
      <div class="relative">
        <h2 class="text-4xl font-extrabold text-white leading-tight">
          Welcome back,<br /><span class="gradient-text">hacker.</span>
        </h2>
        <p class="mt-4 text-ink-muted max-w-sm">
          Pick up where you left off. Your machines, modules, and rank are waiting.
        </p>
      </div>
      <div class="relative flex items-center gap-8">
        <div>
          <p class="text-[11px] text-ink-faint mb-1.5">Brought to you by</p>
          <img src="@/assets/partners/siberlab-logo.png" alt="SiberLab ID" class="h-7" />
        </div>
        <div>
          <p class="text-[11px] text-ink-faint mb-1.5">In partnership with</p>
          <img src="@/assets/partners/redac7d.png" alt="REDAC7D" class="h-7" />
        </div>
      </div>
    </div>

    <!-- Form panel -->
    <div class="flex items-center justify-center p-6 sm:p-12">
      <div class="w-full max-w-md">
        <a href="/" class="lg:hidden flex items-center justify-center gap-2.5 mb-8">
          <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-10" />
          <span class="text-lg font-extrabold text-white">Akademi<span class="text-brand">Siber</span></span>
        </a>

        <h1 class="text-2xl font-extrabold text-white mb-1">Sign in</h1>
        <p class="text-ink-muted text-sm mb-8">Enter your credentials to access your account.</p>

        <form @submit.prevent="login" class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-ink-muted mb-1.5" for="email">Email</label>
            <input v-model="email" class="input" id="email" placeholder="you@example.com" type="email" />
          </div>
          <div>
            <label class="block text-sm font-medium text-ink-muted mb-1.5" for="password">Password</label>
            <input v-model="password" class="input" id="password" placeholder="••••••••" type="password" />
          </div>
          <div class="text-right">
            <a class="text-sm text-ink-muted hover:text-brand" href="/forgot-password">Forgot password?</a>
          </div>
          <button class="btn-primary w-full justify-center py-3" type="submit">Sign In</button>
        </form>

        <div class="flex items-center gap-4 my-6">
          <div class="h-px flex-1 bg-line"></div>
          <span class="text-xs text-ink-faint uppercase tracking-wider">or</span>
          <div class="h-px flex-1 bg-line"></div>
        </div>

        <div class="flex justify-center">
          <GoogleLogin :callback="callback" />
        </div>

        <p class="text-center text-sm text-ink-muted mt-8">
          Don't have an account?
          <a class="font-semibold text-brand hover:text-brand-light" href="/register">Create one</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
toastr.options = {
  positionClass: "toast-bottom-right",
  closeButton: true,
  progressBar: true,
  timeOut: 5000,
};

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async login() {
      try {
        const response = await apiClient.post("/auth/login", {
          email: this.email,
          password: this.password,
        });
        document.cookie = `authToken=${response.data.token}; path=/; max-age=86400;`;
        toastr.success("Login successful!", "Success");
        const redirect = this.$route.query.redirect;
        this.$router.push(redirect && redirect.startsWith("/") && !redirect.startsWith("//") ? redirect : "/dashboard");
      } catch (error) {
        if (error.response && error.response.status === 400) {
          if (error.response.data.message === "Please confirm your email before logging in.") {
            const tambahan = `<a href="/resend-confirmation" class="text-blue-500 hover:underline">CLICK HERE</a>`;
            toastr.error(`Please confirm your email before logging in. ${tambahan} to resend new confirmation email`, "Login Failed");
          } else {
            toastr.error(error.response.data.message, "Login Failed");
          }
        } else {
          toastr.error(error.response.data.message, "Login Failed");
        }
      }
    },
  },
};
</script>
